enum CustomerType {
  B2C = 'B2C',
  B2B = 'B2B',
}

export default CustomerType;
